import { render, staticRenderFns } from "./addOrEditAged.vue?vue&type=template&id=def9cf10&scoped=true"
import script from "./addOrEditAged.vue?vue&type=script&lang=js"
export * from "./addOrEditAged.vue?vue&type=script&lang=js"
import style0 from "./addOrEditAged.vue?vue&type=style&index=0&id=def9cf10&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "def9cf10",
  null
  
)

export default component.exports